import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorWrapper } from '../@shared/models/response-wrapper.model';
import { plainToClassFromExist } from 'class-transformer';
import { PageNotFoundService } from '../@core/page-not-found.service';
import { SeoService } from '../@core/seo.service';
import { ErrorPageData } from '../@shared/error-page/error-page.data';
import { RouteExecutor } from '../@core/application-router/route.executor';
import { ApplicationRouterService } from '../@core/application-router/application-router.service';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent extends RouteExecutor implements OnInit {
    @Input() filter: { [p: string]: string | string[] } = {};

    parentRoute: string | undefined = undefined;

    loading = true;
    errorCaught = false;
    errors: ErrorWrapper[] | ErrorPageData[] | undefined = undefined;

    constructor(
        applicationRouter: ApplicationRouterService,
        private activatedRoute: ActivatedRoute,
        private pageNotFoundService: PageNotFoundService,
        private seoService: SeoService,
        private router: Router
    ) {
        super(applicationRouter);
        // @ts-ignore
        this.parentRoute = this.activatedRoute.snapshot._routerState.url;
        console.log(this.parentRoute);
        if (this.parentRoute === '/privacy-and-security-policy') {
            this.router.navigate(['gp'], {
                queryParams: { f: 'page~static,type~privacyAndSecurityPolicy' },
                queryParamsHandling: 'merge',
                replaceUrl: true,
            });
        }
        this.processLink('/fn/internal?page=page-not-found&action=nav-update');
    }

    ngOnInit() {
        this.pageNotFoundService
            .urlRedirection(this.parentRoute)
            .subscribe(res => {
                if (res?.success) {
                    //  console.log(res, 'value');
                    this.loading = false;
                } else {
                    this.seoService.addMetaTag('render:status_code', '404');
                    this.loading = false;
                    this.errors = res?.errors;
                    this.seoService.updateMetaTitle('Page Not Found');
                }
            });
    }

    executeFunctionLink(
        id: string,
        query: { [p: string]: string | string[] },
        body?: object
    ) {
        super.executeFunctionLink(id, query, body);
    }
}
